/**
 * @file short-number.ts
 * @description Короткий вид складских номеров для узких колонок
 * (phase19.31, SC59): «RCP-2026-000018-1» → «RCP-…018-1».
 *
 * Номер партии и документа склада устроен одинаково: префикс вида, год,
 * порядковый номер с ведущими нулями и, у партии, суффикс строки приёмки.
 * В колонке на 140px целиком он не помещается и обрезался многоточием на
 * середине — терялась как раз различающая часть (хвост). Короткий вид
 * оставляет префикс (что это) и хвост (какой именно); год и нули убираются.
 *
 * Номера другого формата (ручные «L-240517», импортированные) не трогаем:
 * они возвращаются как есть, а ширину ограничивает разметка многоточием.
 * Полный номер вызывающий кладёт в `title` / `aria-label`.
 */

/** Префикс-год-номер[-суффиксы]: «RCP-2026-000018», «RCP-2026-000018-1». */
const DOC_NUMBER = /^([A-ZА-ЯЁ]{1,8})-(\d{4})-(\d+)((?:-\d+)*)$/;

/** Сколько последних цифр порядкового номера оставлять минимум. */
const TAIL_DIGITS = 3;

/**
 * Короткий вид номера. Значащие цифры не теряются: «001234» → «1234»,
 * «000018» → «018» (три цифры читаются ровнее, чем «18»).
 */
export function shortDocNumber(full: string): string {
  const value = full.trim();
  const match = DOC_NUMBER.exec(value);
  if (!match) return value;
  const [, prefix, , seq = "", suffix = ""] = match;
  const significant = seq.replace(/^0+/, "");
  const tail = significant.length > TAIL_DIGITS ? significant : seq.slice(-TAIL_DIGITS);
  return `${prefix}-…${tail}${suffix}`;
}
